import { AnalogIn, AnalogOut, DigitalIn, DigitalOut, IOType } from "../../props/PropTypes";
import { BusManagerBase } from "./BusManagerBase";
import { HdwRackType, isCombiKaart, isSimpleKaart, KaartType } from "./hdw-konfig-types";
import { BusManager, HwdSysteem, Kaart } from "./HdwSysteem";

export class SCXBusManager extends BusManagerBase implements BusManager {
    constructor(systeem: HwdSysteem) {
        super(systeem, "scx");
    }


    public canDeleteRack(rackId: number): boolean {
        if (rackId == 1) {
            return false;
        }
        return true;
    }

    deleteRack(id: number): void {
        super.deleteRack(id);
        let racks = this.getRacks();
        for (let i = 0; i < racks.length; i++) {
            racks[i].number = i + 1;
        }
        this.assignOffsets();
        this.systeem.updateRackId();

    }

    deleteKaart(id: number): void {
        super.deleteKaart(id);
        this.assignOffsets();
    }

    addRack(rackType: HdwRackType): number {
        let id = super.addRack(rackType);
        let rack = this.getRack(id);
        if (rack != undefined) {
            if (rackType.karten.length > 0) {
                let kaart = new Kaart(rackType.karten[0], 1, this.systeem.getNextKaartId());
                rack.addKaart(kaart);

            }
        }
        this.assignOffsets();
        return id;
    }

    private getMaxDipSwitch(ioType: IOType) {
        let racks = this.systeem.getRacks("scx");
        let max = -1;
        for (let rack of racks) {
            for (let kaart of rack.kaarten) {
                if (isSimpleKaart(kaart.type)) {
                    if (new IOType(kaart.type.ioType).equals(ioType) && kaart.dipSwitch > max) {
                        max = kaart.dipSwitch;
                    }
                }
            }
        }
        return max;

    }
    addKaart(kaartType: KaartType, number: number, rackId: number): number {
        let rack = this.getRack(rackId);
        if (rack != undefined) {
            let id = this.systeem.getNextKaartId();
            let kaart;
            if (isSimpleKaart(kaartType)) {
                let dipSwitch = this.getMaxDipSwitch(new IOType(kaartType.ioType)) + 1;
                kaart = new Kaart(kaartType, number, id, dipSwitch);

            } else {
                kaart = new Kaart(kaartType, number, id, rack.kaarten.length);
            }
            rack.addKaart(kaart);
            this.assignOffsets();
            return id;
        }
        return -1;
    }

    public assignOffsets() {
        this.assignOffsetsFor(AnalogIn);
        this.assignOffsetsFor(AnalogOut);
        this.assignOffsetsFor(DigitalIn);
        this.assignOffsetsFor(DigitalOut);
        // let racks = this.systeem.getRacks("scx");
        // for (let rack of racks) {
        //     for (let kaart of rack.kaarten) {
        //         if (isSimpleKaart(kaart.type)) {
        //             let ioType = new IOType(kaart.type.ioType);
        //             if (ioType.equals(AnalogIn)) {
        //                 kaart.setOffset(kaart.type.available * (kaart.dipSwitch - 1) + 2, ioType);
        //             } else {
        //                 kaart.setOffset(kaart.type.available * (kaart.dipSwitch - 1) + 1, ioType);
        //             }

        //         }
        //     }
        // }
    }

    public assignOffsetsFor(ioType: IOType) {
        let cards: Kaart[] = [];
        let racks = this.systeem.getRacks("scx");
        for (let rack of racks) {
            for (let kaart of rack.kaarten) {
                if (isSimpleKaart(kaart.type) && new IOType(kaart.type.ioType).equals(new IOType(ioType))) {
                    cards.push(kaart);
                }
                if (isCombiKaart(kaart.type)) {
                    cards.push(kaart);
                }
            }
        }
        cards.sort((a, b) => a.dipSwitch - b.dipSwitch);
        for (let kaart of cards) {
            let dip = kaart.dipSwitch;
            let offset = dip * kaart.getReservedIOS(ioType);
            if (ioType.equals(AnalogIn)) {
                offset = offset + 2;
            } else {
                offset = offset + 1;
            }
            kaart.setOffset(offset, ioType);
        }
    }
}